import React from 'react';
import SoundButton from './SoundButton';
import SoundDivider from './SoundDivider';
import deathknights from './assets/deathknights.json';
import galakronds from './assets/galakronds.json';
import { View, Text } from 'react-native';
import DeviceContext from './DeviceContext'
import {defaultHeroSounds, deathKnightHeroSounds, deathKnightRexxarHeroSounds, AVHeroCards,
  sharedCustomHeroSounds, galakrondHeroSounds, ragAndLordJarraxxusHeroSounds, medivhHeroSounds, renoHeroSounds, complicatedAltSound, 
  battlegroundBartenderIDs, bartenderSounds, customVenari, heroCardCustomSounds, buildHeroSoundArray} from './HelperFunctions'

const HeroSounds = (props) => {

  let card = props.card
  let cardID = card.id
  let deviceType = React.useContext(DeviceContext)

  const RenderSoundArrays = (props) => {
    if (deathknights.map(a => a.id).includes(cardID) && cardID != "ICC_828") return <SoundArray soundArrays={deathKnightHeroSounds}/>
    else if (cardID == 'ICC_828') return <SoundArray soundArrays={deathKnightRexxarHeroSounds}/>
    else if (['BOT_238','GIL_504','TRL_065'].includes(cardID)) return <SoundArray soundArrays={sharedCustomHeroSounds}/>
    else if (cardID == 'YOD_009') return <SoundArray soundArrays={renoHeroSounds}/>
    else if (['EX1_323h','CORE_EX1_323','BRM_027h'].includes(cardID)) return <SoundArray soundArrays={ragAndLordJarraxxusHeroSounds}/>
    else if (cardID == 'HERO_08a') return <SoundArray soundArrays={medivhHeroSounds}/>
    else if (galakronds.map(a => a.id).includes(cardID)) return <SoundArray soundArrays={galakrondHeroSounds}/>
    else if (cardID == 'TB_BaconShopBob_SKIN_B') return <SoundArray soundArrays={customVenari}/>
    else if (battlegroundBartenderIDs.includes(cardID)) return <SoundArray soundArrays={bartenderSounds}/>
    else if (AVHeroCards.includes(cardID)) return <SoundArray soundArrays={heroCardCustomSounds} />
    else return <SoundArray soundArrays={buildHeroSoundArray(card)} rework={true}/>
  }

  const SoundArray = (props) => {
    return (
      <View style={{alignSelf: 'flex-start', width: "100%"}}>
        {props.soundArrays.map(section => (
          <> {props.rework ? 
            <SoundButtonArray sectionTitle={section["title"]} sounds={section["sounds"]} rework={props.rework}/> :           
            <SoundButtonArray sectionTitle={section[0]} sounds={section[1]} rework={props.rework}/>
          }
          </>
        ))}
      </View>
    )
  }

  const SoundButtonArray = (props) => {
    return (
      <>
        <View style={{flexDirection: 'row', paddingBottom: 8}}>
          <Text style={{paddingTop: 4, alignSelf: 'flex-start', fontWeight: 'bold', width: "15%", fontSize: deviceType == 'mobile' ? 10.5 : 14}}>{props.sectionTitle}</Text>
          <View style={{flexDirection: 'row', flexWrap: 'wrap', width: "85%"}}> 
              {props.sounds.map(sound => ( 
                <>
                {props.rework ? 
                  <SoundButton title={sound["buttonName"]} sound={sound.audio}/> :
                  <SoundButton title={sound[0]} cardID={complicatedAltSound(cardID, sound[1])} sound={complicatedAltSound(cardID, sound[1]) + '_' + sound[1]}/>
                }
                </>
              ))}
          </View>
        </View>
        <SoundDivider />
      </>
    )
  }

  return (
    <View style={{alignSelf: 'flex-start', width: "100%"}}>
      <RenderSoundArrays/>
    </View>
  )
}

export default HeroSounds
